import SpotContainer from './SpotContainer'

export default SpotContainer
